import {
  X,
  Printer,
  Download,
  ArrowDownCircle,
  ArrowUpCircle,
  Landmark,
  Calendar,
  FileText,
} from "lucide-react";

export default function BankTransactionViewModal({
  transaction,
  onClose,
}) {
  if (!transaction) return null;

  const receipt = transaction.type === "Receipt";

  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50 flex items-center justify-center">

      <div className="w-full max-w-3xl rounded-2xl bg-[#0b0b0f] border border-white/10 overflow-hidden">

        {/* Header */}
        <div className="flex justify-between items-center px-8 py-5 border-b border-white/10">

          <div>
            <h2 className="text-2xl font-serif">
              Bank Transaction
            </h2>

            <p className="text-xs text-gray-400 mt-1">
              Voucher Details
            </p>
          </div>

          <button
            onClick={onClose}
            className="p-2 rounded-lg hover:bg-white/10"
          >
            <X size={18} />
          </button>

        </div>

        {/* Body */}
        <div className="p-8 space-y-8">

          {/* Status Card */}

          <div className="rounded-2xl border border-white/10 bg-white/5 p-6">

            <div className="flex justify-between items-center">

              <div className="flex items-center gap-4">

                <div
                  className={`w-14 h-14 rounded-2xl flex items-center justify-center
                  ${
                    receipt
                      ? "bg-emerald-500/20"
                      : "bg-red-500/20"
                  }`}
                >
                  {receipt ? (
                    <ArrowDownCircle
                      className="text-emerald-400"
                      size={28}
                    />
                  ) : (
                    <ArrowUpCircle
                      className="text-red-400"
                      size={28}
                    />
                  )}
                </div>

                <div>

                  <p className="text-sm text-gray-400">
                    Transaction Type
                  </p>

                  <h3 className="text-2xl font-serif">
                    {transaction.type}
                  </h3>

                </div>

              </div>

              <div className="text-right">

                <p className="text-sm text-gray-400">
                  Amount
                </p>

                <h2
                  className={`text-3xl font-serif ${
                    receipt
                      ? "text-emerald-400"
                      : "text-red-400"
                  }`}
                >
                  ₹
                  {Number(
                    transaction.amount
                  ).toLocaleString()}
                </h2>

              </div>

            </div>

          </div>

          {/* Details */}

          <div className="grid md:grid-cols-2 gap-6">

            <InfoCard
              icon={Calendar}
              label="Date"
              value={transaction.date}
            />

            <InfoCard
              icon={Landmark}
              label="Bank"
              value={transaction.bank}
            />

            <InfoCard
              icon={FileText}
              label="Category"
              value={transaction.category}
            />

            <InfoCard
              icon={FileText}
              label="Reference"
              value={
                transaction.reference || "-"
              }
            />

          </div>

          {/* Description */}

          <div className="rounded-2xl border border-white/10 bg-white/5 p-6">

            <p className="text-xs uppercase tracking-widest text-gray-400 mb-3">
              Description
            </p>

            <p className="text-gray-300 leading-7">
              {transaction.description ||
                "No description available."}
            </p>

          </div>

        </div>

        {/* Footer */}

        <div className="flex justify-end gap-3 border-t border-white/10 px-8 py-5">

          <button
            className="flex items-center gap-2 px-5 py-3 rounded-xl border border-white/10 hover:bg-white/5"
          >
            <Printer size={16} />
            Print
          </button>

          <button
            className="flex items-center gap-2 px-5 py-3 rounded-xl border border-white/10 hover:bg-white/5"
          >
            <Download size={16} />
            Download
          </button>

          <button
            onClick={onClose}
            className="px-6 py-3 rounded-xl bg-amber-400 text-black font-semibold"
          >
            Close
          </button>

        </div>

      </div>

    </div>
  );
}

function InfoCard({ icon: Icon, label, value }) {
  return (
    <div className="rounded-xl bg-white/5 border border-white/10 p-5">

      <div className="flex items-center gap-3 mb-3">

        <div className="w-10 h-10 rounded-lg bg-amber-400/10 flex items-center justify-center">
          <Icon
            size={18}
            className="text-amber-400"
          />
        </div>

        <span className="text-xs uppercase tracking-widest text-gray-400">
          {label}
        </span>

      </div>

      <p className="text-lg font-medium">
        {value}
      </p>

    </div>
  );
}